export const environment = {
  envName: 'test',
  production: false,
  authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/v2.0',
  clientId: '39a2c485-8d51-45e7-be7e-52c200206157',
  redirectUri: `${location.protocol}//${location.hostname}${location.port && ':' + location.port}/`,
  audience: 'https://iopoc-test.azure.chevron.com',
  knownAuthorities: ['https://login.microsoftonline.com', 'https://sts.windows.net'],
  apiUrl: 'https://iopoc-api-test.azure.chevron.com/api',
  engineApiUrl: 'https://workflow-api-test-cvx.whiteocean-6372b382.southcentralus.azurecontainerapps.io',
  engineScope: 'https://workflow-engine-dev.azure.chevron.com/user_impersonation',
  appInsightsConnectionString: '__APPINSIGHTS_CONNECTION_STRING__',
  appInsightsCorrelateEngine: false,
  useMockData: false,
  agentRunRerunsEnabled: true,
};
